var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Html } from "@react-three/drei";
import React from "react";
// TODO ADD THIS STYLESHEET VIA CDN REFERENCE IN FUTURE
// import "./VtHtmlHotspotViewerMesh.css";
import { VTHTMLHotspotWithControls } from "./VTHTMLHotspotWithControls";
export var VTHTMLHotspotWithControlsMesh = React.forwardRef(function (props, ref) {
    var position = props.position, _a = props.scale, scale = _a === void 0 ? 8 : _a, _b = props.transform, transform = _b === void 0 ? false : _b;
    return (_jsx("mesh", __assign({ ref: ref, position: position }, { children: _jsx(Html, __assign({ wrapperClass: "vt-html-hotspot-viewer", transform: transform, scale: scale, center: true, as: "div", zIndexRange: [0, 1] }, { children: _jsx(VTHTMLHotspotWithControls, __assign({}, props)) })) })));
});
